/**
 * AiAgentStatus — mirrors AgentSessionStatus from the backend.
 */
export enum AiAgentStatus {
    /** Session created, agent not yet started */
    PENDING = 'PENDING',

    /** Agent is actively processing */
    RUNNING = 'RUNNING',

    /** Agent finished with zero validation errors */
    COMPLETED = 'COMPLETED',

    /** Agent finished but some validation errors remain */
    COMPLETED_WITH_WARNINGS = 'COMPLETED_WITH_WARNINGS',

    /** Agent encountered an unrecoverable error */
    FAILED = 'FAILED',
}
